<template>
    <div>
        <el-container>
            <div class="article-list-main">
                <div class="article-list-container">
                    <el-card class="article-list-item-container" v-for="(item,index) in articleList" :key="index">
                        <!--<router-link :to="'/article/articleDetail/' + item.id"><a @click="getArticleId(item.id)">{{item.title}}</a></router-link>-->
                        <router-link class="article-list-item" :to="'/article/articleDetail/' + item.id" target="_blank">
                            <div @click="addViewCount(item.id)">
                                <h3 style="margin: 0px auto 6px">{{item.title}}</h3>
                            </div>
                        </router-link>
                        <div style="display: flex">
                            <p style="font-size: 14px;color: #6d6868;margin: 0">{{item.summary}}</p>
                            <div style="font-size: 14px;margin-left: auto">浏览量：{{item.viewCount}}</div>
                        </div>


                        <!--<router-link :to="'/article/articleDetail/' + item.id" target="_blank">-->
                            <!--<a @click="addViewCount(item.id)">查看详情</a>-->
                        <!--</router-link>-->

                        <!--<div style="font-size: small;float: right">浏览量：{{item.viewCount}}</div>-->
                    </el-card>
                </div>

                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        @prev-click="handlePrevClick"
                        @next-click="handleNextClick"
                        :current-page="currentPage"
                        :page-sizes="[10 , 20, 30, 40 ,50 ,60]"
                        :page-size="30"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total=total>
                </el-pagination>
            </div>
        </el-container>
    </div>
</template>

<script>
    import {getArticleListByPager} from "@/api/get";
    import {addViewCount} from "@/api/post";

    export default {
        name: "ArticleList",
        props: {
            level1ColumnId: {
                type: String,
                // default: ""
            }
        },
        data() {
            return {
                articleList: [],
                total: 0,
                currentPage: 1,
                pageNum: 1,
                pageSize: 30,
            }
        },
        watch: {
            /*监听左侧导航栏level1ColumnId的变化*/
            level1ColumnId: {
                handler() {
                    // console.log("ok")
                    // this.getLevel1Column()
                    this.getLevel1Column(this.pageNum, this.pageSize)
                },
                immediate: true
            }
        },
        created() {
            this.getLevel1Column(this.pageNum, this.pageSize)
        },
        methods: {
            addViewCount(articleId) {
                //文章流量数+1
                addViewCount(articleId).then();
            },

            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val
                this.getLevel1Column(this.pageNum, val)
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.pageNum = val
                this.getLevel1Column(val, this.pageSize)
            },
            handlePrevClick(val) {
                // console.log("prev"+val)
                this.getLevel1Column(val, this.pageSize)
            },
            handleNextClick(val) {
                // console.log("next"+val)
                this.getLevel1Column(val, this.pageSize)
            },

            getLevel1Column(pageNum, pageSize) {
                const level1ColumnId = this.level1ColumnId;
                if (level1ColumnId === null || level1ColumnId === undefined || level1ColumnId === '') {
                    return
                } else {
                    // getArticleListByLevel1ColumnId(level1ColumnId).then(response => {
                    getArticleListByPager(level1ColumnId, pageNum, pageSize).then(response => {
                        this.articleList = response.rows
                        this.total = response.total
                        // console.log("1"+"getArticleListByLevel1ColumnId这里"+response.rows)
                    });
                }
            },

            // getArticleId(id){
            //     console.log("文章id"+id)
            // }
        }
    }
</script>

<style scoped>
    .article-list-main {
        /*border: black 1px solid;*/
        /*border: #6495ED 1px solid;*/
        padding: 10px;
        width: 100%;
        /*box-shadow: 0 4px 6px rgba(0, 0, 0, .12), 0 0 8px rgba(0, 0, 0, .04);*/
        /*box-shadow: 0 2px 4px black, 0 0 6px rgba(0, 0, 0, .12);*/
        border-radius: 6px;
        /*background: #F7F7F7;*/
    }

    .article-list-item-container {
        /*border: #6495ED 1px solid;*/
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        /*padding-bottom: 30px;*/
        /*padding-left: 30px;*/
        /*margin-bottom: 30px;*/
        /*background: #F7F7F7;*/
    }

    .article-list-item-container :hover{
        background: #f9f9f9;
    }

    .article-list-item :hover{
        color: #6495ED;
    }

    .article-list-item{
        text-decoration: none;
        color: black;
    }
</style>
